<app-loading-spinner *ngIf="isLoading" [inline]="1"></app-loading-spinner>
<div class="main-content-area mt-4 container-resource-page" *ngIf="bitesize">
  <div [innerHTML]="$safeNavigationMigration(bitesize?.overview) | safeHtml"></div>

  <!-- is there a video? -->
   <video
        width="100%"
        *ngIf="bitesize && bitesizeVideos[bitesize.bitesize_session_id]"
        controls
        preload
        class="fade-in drop-shadow mb-3"
        controlsList="nodownload"
      >
        <source [src]="environment.staticUrl + '/' + bitesizeVideos[bitesize.bitesize_session_id]" type="video/mp4" />
      </video>

  <pdf-viewer
    *ngIf="bitesize.pdf_filename"
    [src]="'/assets/pdf/' + bitesize.pdf_filename"
    [render-text]="true"
    [original-size]="false"
    style="width: 100%; height: 90vh"
  ></pdf-viewer>

  <div class="text-center mt-4">
    <a
      class="btn btn-primary"
      href="./assets/pdf/{{ bitesize.pdf_filename }}"
      target="_blank"
    >
      <span class="icon-wrap"
        ><fa-icon [icon]="['far', 'file-download']"></fa-icon
      ></span>
      Download</a
    ><br><br><a
    class="btn btn-primary"
          [routerLink]="['/dashboard']"
  >
   
    Back to Dashboard</a
  ><br>
  </div>
</div>
<app-footer-expired *ngIf="userData?.expired"></app-footer-expired>